<script>
import { ActionCableService } from './services';
import { Duration } from 'luxon';
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    data(){
        return {
            show_info: false,
            openedTab: 0,
        }
    },
    props:{
        topic: null,
        topic_duration: null,
    },
    computed:{
        user(){
            return this.findUser(this.topic.responsible_id);
        },
        displayDuration(){
            var total_duration = this.topic.duration
            if(this.topic.finished_at && this.topic.start_at){
                var date_init = new Date(this.topic.start_at)
                var date_fini = new Date(this.topic.finished_at)
                total_duration = (date_fini - date_init)/(1000*60)
            }
            return Duration.fromObject({ minutes: total_duration }).toFormat('mm:ss');
        },
        displayPlannedDuration(){
            if(this.topic.id == this.currentTopic){
                this.topic.duration = this.topic_duration;
            }
            return Duration.fromObject({ minutes: this.topic.duration }).toFormat('mm:ss');
        },
        displayAttachmentsAmount(){
            var amount = 0;
            if(this.topic.file_paths){
                amount = this.topic.file_paths.length;
            }
            return amount;

        },
        isFinished(){
            return this.topic.finished_at !== null;
        },
        topicClass(){
            return {
                'topic-info': true,
                'finished-topic': this.isFinished,
                'pending-topic': !this.isFinished
            }
        },
        canStartTopic(){
            return !this.isFinished && !this.meetFinished;
        },
        ...mapGetters('operationModule',['currentTopic', 'findUser', 'meetFinished'])
    },
    methods:{
        chooseTopic(){
            ActionCableService.chooseTopic({topicId: this.topic.id});
        },
        changeShowInfo(){
            this.show_info = !this.show_info
        }
    }
}
</script>